"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.perDeploymentEnv = void 0;
const perDeploymentEnv = (value) => value;
exports.perDeploymentEnv = perDeploymentEnv;
